import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 35rem;
  gap: 2rem;
  padding-bottom: 3rem;
`;
